import {
    Component,
    OnChanges,
    Input,
    LOCALE_ID,
    Inject,
    Output,
    EventEmitter,
    SimpleChanges,
    OnDestroy,
    ViewChild,
    ElementRef,
    effect} from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { EnrollPatientDeviceDataService } from '../../services/enroll-patient-device-data.service';
import {
    PatientDeviceDataModel,
    DropDownModel,
    PatientDeviceModel,
    PatientDetailsModel,
} from '../../models/enroll-patient-device-data.model';
import { ActivatedRoute, Router } from '@angular/router';
import {
    GridService,
    GridState,
} from 'merlin-library';
import { MatDialog } from '@angular/material/dialog';
import { HelperService } from 'merlin-core';
import { AbstractControl } from '@angular/forms';

import { DatePipe } from '@angular/common';
import { DateTimeService } from '../followup-schedule/date-time.service';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from '../followup-schedule/customDateAdapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { UserProfileObject, UserService } from 'merlin-library';
import { ViewEncapsulation } from '@angular/core';
import {
    LocalizationService,
    ReturnType,
} from 'src/core/utilitites/localization.service';
import { ToastrService } from 'ngx-toastr';
import { PatientProfilePrintDialogComponent } from '../../patient-profile-print-dialog/patient-profile-print-dialog.component';
import { FunctionMode } from '../enums/enroll-patient.enum';
import { PatientListService } from '../../services/patient-list.service';
import { ReleasePatientDialogComponent } from '../../release-patient-dialog/release-patient-dialog.component';
import { PatientTransferRequestClinicService } from '../../services/patient-transfer-request-clinic.service';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { TransmissionDetailService } from '../../services/transmission-detail.service';
import { CommonService } from '../../../shared/service/common.service';
import { PatientFinderService } from '../../patient-finder/patient-finder.service';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { PDMP1SARW, PROG_STATE_FAIL_CD, PROG_STATE_PENDING_CD } from '../../../constants/Programming_Failure_Reason_Cd.constants';
import { RemoteProgrammingService } from '../../remote-programming/remote-programming.service';
import { EditPatientDeviceDataComponent } from './edit-patient-device-data/edit-patient-device-data.component';
import { GlobalInputSecurityService } from 'src/core/utilitites/global-input-security.service';
import { V } from '@angular/cdk/scrolling-module.d-ud2XrbF8';
import { IdentifierService } from 'merlin-core';
export const isControlRequired = (control: AbstractControl): boolean => {
    if (!control) {
        return false;
    }

    if (control.validator) {
        const validator = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            if (!control.value || control.value === '') {
                return true;
            } else {
                return false;
            }
        }
    }
    if (control?.errors?.required) {
        return true;
    }

    return false;
};

export const PICK_FORMATS = {
    parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Component({
    selector: 'app-manual-patient-device-data',
    templateUrl: './patient-device-data.component.html',
    styleUrls: ['./patient-device-data.component.scss'],
    providers: [
        DatePipe,
        DateTimeService,
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [DateTimeService],
        },
        { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PatientDeviceDataComponent implements OnChanges, OnDestroy {
    public dropDownInfo: DropDownModel = new DropDownModel();
    public patientDeviceInfo: PatientDeviceModel;
    private destroy$ = new Subject<void>();
    private profileSubscription: Subscription;
    patientInfo: any;
    displayMode: string = FunctionMode.VIEW;
    patRes: any = {};
    msg1: string = '';
    msg2: string = '';
    msg3: string = '';
    hasPatientDataEntryAccess: boolean;
    // find out where it is set
    isPatientRelease: boolean = false;
    isSP2CanEnroll: boolean;
    isSavebtnClick: boolean;
    noEdit: boolean;
    activatorClinicFlg: boolean = false;
    userProfile: UserProfileObject;
    releasePatientMsg: string;
    rpCapableFlag: boolean;

    @ViewChild(EditPatientDeviceDataComponent) editComponent!: EditPatientDeviceDataComponent;

    @Input('functionMode') functionMode: string;
    @Input() patientid;
    @Input() isBack;
    @Input() defaultPatientDetails: PatientDetailsModel;
    @Input() isActiveStep: boolean = true;
    @Output() navigateToTrans = new EventEmitter();
    @Output() getPatientId = new EventEmitter();
    @Output() setPatientHeader = new EventEmitter();
    @Output() setSubMenu = new EventEmitter();

    public stringLabels = [
        "label.gb.pat_dev_data",
        "label.gb.pat_prof",
        "label.gb.edit",
        "label.gb.button_cancel",
        "label.gb.save",
        "label.gb.print_profile",
        "label.gb.release_patient",
        "label.gb.more_actions",
        "label.gb.reactivate_pat",
        "label.gb.required_field",
        "label.gb.button_cancel",
        "label.gb.saveandclose",
        "label.gb.continue",
    ]

    public labels: Record<string, string>;

    constructor(
        private helperService: HelperService,
        private router: Router,
        private userService: UserService,
        @Inject(LOCALE_ID) public locale: string,
        private enrollService: EnrollPatientDeviceDataService,
        private dialog: MatDialog,
        private localizationService: LocalizationService,
        private toasterService: ToastrService,
        private route: ActivatedRoute,
        private patientListService: PatientListService,
        private requestService: PatientTransferRequestClinicService,
        private transmissionDetailService: TransmissionDetailService,
        private commonService: CommonService,
        private patientFinderService: PatientFinderService,
        private gridService: GridService,
        public identifierService: IdentifierService,
        private remoteProgrammingService: RemoteProgrammingService,
        private elementRef: ElementRef,
        private globalInputSecurity: GlobalInputSecurityService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isBack != undefined) {
            if (changes.isBack.currentValue) {
                this.setDisplayMode(FunctionMode.ENROLL);
                this.functionMode = FunctionMode.ENROLL;
            }
        }
        if (changes?.functionMode?.currentValue === FunctionMode.ENROLL) {
            this.setDisplayMode(FunctionMode.ENROLL);
        }
    }

    ngOnInit() {
        this.translateStrings();
        localStorage.setItem('rpCapableFlg', 'false');
        this.route.params.subscribe((res) => {
            if (res?.id) {
                this.patientid = res.id;
                this.enrollService.patientId.next(res.id);
            }
        });

        this.enrollService.updateDeviceFormDirty(false);
    }

    ngOnDestroy(): void {
        if(this.profileSubscription){
            this.profileSubscription.unsubscribe();
        }
        this.enrollService.showEmergencyContactPopup.next(false);
        this.destroy$.next();
        this.destroy$.complete();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    reActivatePatient() {
        if (this.hasPatientDataEntryAccess) {
            this.patientListService
                .updateReactivatePatient([this.patientid])
                .subscribe(
                    (res) => {
                        // TO DO set in child component
                        this.isSavebtnClick = false;
                        this.toasterService.success(
                            this.translate(
                                'msg.pa800b.text',
                                { 0: '1' },
                                ReturnType.HTML
                            )
                        );
                        this.isPatientRelease = false;
                    },
                    (err) => {
                        this.helperService.showErrorToastr(err);
                    }
                );
        }
    }

    releasePatient() {
        if (this.isSP2CanEnroll) {
            const patientIds = [this.patientid];

            this.patientListService.getReleasePatientData(patientIds).subscribe(
                (res) => {
                    const releasePatientDRef = this.dialog.open(
                        ReleasePatientDialogComponent,
                        {
                            width: '900px',
                            // height:'600px',
                            data: {
                                patients: res.releasePatientSummaryDTO.map(
                                    (a) => {
                                        a.patientInfo[
                                            'isTransmissionComplete'
                                        ] = a.isTransmissionComplete;
                                        return a.patientInfo;
                                    }
                                ),
                                clinicFavoriteDTO: res.clinicFavoriteDTO,
                                releaseReasonCd: res.releaseReasonCd,
                                transferCustApplId: res.transferCustApplId,
                                countryCodes: this.dropDownInfo.countryCodes,
                            },
                        }
                    );

                    releasePatientDRef.afterClosed().subscribe((result) => {
                        if (result.reasonForReasonFlag) {
                            const selectedIds = [Number(this.patientid)];
                            let data = {
                                patientIds: selectedIds,
                                releaseReasonCode: result.reasonForReasonFlag,
                                transferCustApplId: result.transferCustApplId
                                    ? result.transferCustApplId
                                    : '',
                            };
                            this.patientListService
                                .updateReleasePatient(data)
                                .pipe(
                                    switchMap((res) => {
                                        if (this.rpCapableFlag) {
                                            const programmingFailureReasonCd = PDMP1SARW;
                                            const programmingSessionStateCd = PROG_STATE_FAIL_CD;
                                            const patientDevice = this.enrollService.getPrimaryPatientDevice(this.patientDeviceInfo);
                                            const res$ = (patientDevice?.patientRpCapableFlg && result.reasonForReasonFlag !== 'R') ?
                                             this.enrollService.updatePatientProfile(patientDevice?.patientDeviceId,
                                                { programmingSessionStateCd, programmingFailureReasonCd }).pipe(catchError((err => of(true)))) : of({})
                                            return res$.pipe(map((_) => res))
                                        }
                                        return of(res);
                                    })
                                )
                                .subscribe((response) => {
                                    const refTransferCusDetails =
                                        res.clinicFavoriteDTO &&
                                        res.clinicFavoriteDTO.find(
                                            (a) =>
                                                a.associatedCustApplId ===
                                                result.transferCustApplId
                                        );
                                    let releasePatient = this.translate(
                                        'msg.pa834b.text',
                                        {},
                                        ReturnType.HTML
                                    );

                                    if (refTransferCusDetails) {
                                        releasePatient += ` ${refTransferCusDetails.name} : ${refTransferCusDetails.phoneNum} `;
                                    }
                                    if (
                                        result.reasonForReasonFlag === 'R'
                                    ) {
                                        if (result?.selectedClinicDetails) {
                                            const phone = `${result.selectedClinicDetails.countryCode}-${result.selectedClinicDetails.areaCode}-${result.selectedClinicDetails.phoneNum}`;
                                            const releaseTxt = this.activatorClinicFlg ? 'msg.patrel_actclinic.text' : 'msg.patrel_regclinic.text';
                                            releasePatient = result.selectedClinicDetails.customerId != null
                                                ? this.translate(releaseTxt,
                                                    {
                                                        0: result.selectedClinicDetails.name,
                                                        1: phone,
                                                    }, ReturnType.HTML
                                                ) : this.activatorClinicFlg ? '' : this.translate('msg.pa834a.text', null, ReturnType.HTML);
                                        } else {
                                            releasePatient = this.activatorClinicFlg ? '' : this.translate('msg.pa834a.text', null, ReturnType.HTML);
                                        }                                        
                                        this.isPatientRelease = releasePatient!== '';
                                        this.releasePatientMsg = releasePatient;
                                    } else {
                                        this.isPatientRelease = false;
                                        this.releasePatientMsg = '';
                                    }
                                    if (this.profileMode()) {
                                        // set in child component
                                        this.isSavebtnClick = false;
                                        this.toasterService.success(
                                            this.localizationService.generateLocalizedStr(
                                                'msg.pa834b.text'
                                            )
                                        );
                                    }
                                });
                        }
                    });
                },
                (err) => {
                    this.helperService.showErrorToastr(err);
                }
            );
        }
    }

    getPatientProfile(res) {
        if (res && this.activatorClinicFlg) {
            let banner = {
                deviceFullDescription: res?.patientDevices?.[0]?.deviceFullDescription,
                firstName: res?.patient?.firstName,
                lastName: res?.patient?.lastName,
                patientNum: res?.patient?.patientNum
            }
            this.transmissionDetailService.setBanner(banner);
        }
        this.enrollService.setAssociatedClinicFlag(res.clinicDetails.associatedClinicFlg);
        this.enrollService.setPatientRpCapableFlg(res?.patientDevices?.[0]?.patientRpCapableFlg);
        this.isPatientRelease = res?.patient?.patientStatusCd === 48 && res?.actionMsg !== null;
        this.setReleasePatientMessage(res);

        this.patientInfo = res;
        if (
            this.patientInfo.showDeviceAtEos != null &&
            this.patientInfo.showDeviceAtEos != false
        ) {
            this.msg1 = this.translate('msg.pa900.text', null, ReturnType.Text);
        } else {
            this.msg1 = "";
        }
        if (
            this.patientInfo.correctAbbrDevModelDesc != null &&
            this.patientInfo.correctAbbrDevModelDesc != ''
        ) {
            this.msg2 = this.translate(
                'msg.pa899.text',
                { '0': this.patientInfo.correctAbbrDevModelDesc },
                ReturnType.Text
            );
        } else {
            this.msg2 = "";
        }

        if (
            this.patientInfo.showYellowBannerForApp != null &&
            this.patientInfo.showYellowBannerForApp != false
        ) {
            this.msg3 = this.translate('msg.pa890.text', null, ReturnType.Text);
        } else {
            this.msg3 = "";
        }
    }

    public checkInsInfo(isSaveClick, isContinueClick, emergency: boolean = false) {
        this.clearChachedViewApiVals();
        this.editComponent.checkInsInfo(isSaveClick, isContinueClick, emergency);
    }

    onSaveAndCloseWithXssValidation(): void {
        const scope = this.elementRef.nativeElement;
        if (!this.globalInputSecurity.validateScopeForXss(scope)) {
            return;
        }
        this.checkInsInfo(true, false);
    }

    profileMode() {
        if (this.functionMode === FunctionMode.PROFILE) {
            return true;
        } else {
            return false;
        }
    }

    isTP() {
        this.gridService.getgridState('patient-grid').subscribe((gridState: GridState) => {
            this.noEdit = gridState?.primaryFilter !== 'TP'
        })
        return this.noEdit;
    }

    viewMode() {
        if (this.displayMode === FunctionMode.VIEW) {
            return true;
        } else {
            return false;
        }
    }

    editMode() {
        if (this.displayMode === FunctionMode.EDIT) {
            return true;
        } else {
            return false;
        }
    }

    setDisplayMode(value: string) {
        this.displayMode = value;
    }

    setParentDisplayMode = (value: string) => {
        this.displayMode = value;
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    cancelEditClick() {
        this.clearChachedViewApiVals();
        //this.isSavebtnClick = false;
        this.editComponent.isSavebtnClick = false;
        this.toasterService.clear();
        //this.cancel();
        this.editComponent.cancel();
        this.enrollService.updateDeviceFormDirty(false);
        this.commonService.setDataCorrectedValue(false);
    }

    setHeader(data) {
        this.setPatientHeader.emit({
            name: `${data.patient.firstName} ${data.patient.lastName}`,
            deviceName: this.getDeviceName(data),
            num: data.patient.patientNum,
        });
    }

    getDeviceName(data) {
        let patDevice = data.dropdowns?.devices.filter((dev) => {
            return dev.value == data.patientDevices?.[0]?.productId;
        });
        if (patDevice.length == 0) {
            return '';
        }
        return patDevice[0].label;
    }


    emitSubMenuData(val: boolean) {
        this.setSubMenu.emit(val);
    }

    openPrintDialog() {
        const dialogRef = this.dialog.open(PatientProfilePrintDialogComponent, {
            data: {
                patientid: this.patientid,
                patRes: this.patRes,
            },
        });
        dialogRef.afterClosed().subscribe((result) => { });
    }

    emitNavToTrans(e){
        this.navigateToTrans.emit(e);
    }

    emitGetPatientId(e){
        this.getPatientId.emit(e);
    }

    translate(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }

    // These apis are caching values since they are called on the view component first and the edit component
    private cachedGetUserObsFuncVal;
    getUserObsFunc = (callback: (user: UserProfileObject) => void) => {
        if(this.cachedGetUserObsFuncVal){
            callback(this.cachedGetUserObsFuncVal);
        } else {
            this.userService.getUserObs().subscribe((existingUser: UserProfileObject) => {
                this.setUserProfileVals(existingUser);
                this.cachedGetUserObsFuncVal = existingUser;
                callback(existingUser);
            });
        }
    }

    private cachedGetUserProfFuncVal;
    getUserProfFunc = (callback: (user: UserProfileObject) => void) => {
        if(this.cachedGetUserProfFuncVal){
            callback(this.cachedGetUserProfFuncVal)
        } else {
            //console.log("calling 2");
            this.userService.getUserProfile(false).subscribe((userProfile) => {
                this.setUserProfileVals(userProfile);
                this.cachedGetUserProfFuncVal = userProfile;
                callback(userProfile);
            });
        }
    }

    setUserProfileVals = (userProfile) => {
        this.userProfile = userProfile;
        this.activatorClinicFlg = userProfile.activatorClinicFlg;
        this.isSP2CanEnroll = userProfile.customerType === 'CL'
                            ? true
                            : userProfile?.customerType === 'SP2' &&
                              userProfile?.canEnroll;
        this.hasPatientDataEntryAccess = userProfile.canEnroll;
    }

    setDeviceData = (deviceData) => {
        // set the edited patient data to cache
        if(this.cachedGetDeviceDataFuncVal){
            this.cachedGetDeviceDataFuncVal.medTeam = deviceData?.medTeam;
            this.cachedGetDeviceDataFuncVal.patientDevices = deviceData?.patientDevices;
            this.cachedGetDeviceDataFuncVal.patient = deviceData?.patient;
            this.cachedGetDeviceDataFuncVal.messaging = deviceData?.messaging;
        }
    }

    private cachedGetDeviceDataFuncVal;
    getDeviceDataFunc = (
        funcMode,
        patId,
        callback: (res: any) => void,
        errorCallback?: (err: any) => void
    ) => {
        if(this.cachedGetDeviceDataFuncVal){
            callback(this.cachedGetDeviceDataFuncVal);
        } else {
            this.profileSubscription = this.enrollService
            .getDeviceData(funcMode, patId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    try {
                        this.setPatientProfileVals(res);
                        this.patRes = res;
                        this.cachedGetDeviceDataFuncVal = res;
                        callback(res);
                    } catch (error) {
                        console.log(error);
                    }
                },
                (err) => {
                    errorCallback(err);
                }
           );
        }
    }

    clearChachedViewApiVals = () => {
        this.cachedGetDeviceDataFuncVal = null;
        this.cachedGetUserObsFuncVal = null;
        this.cachedGetUserProfFuncVal = null;
    }

    // These api calls have no chaching mechanism since they are called during edit and enrollment
    getUpdateReactivatePatientFunc = (
        patientIdList,
        callback: (res: any) => void,
        errorCallback?: (err: any) => void
    ) => {
        this.patientListService
            .updateReactivatePatient(patientIdList)
            .subscribe(
                (res) => {
                    callback(res)
                },
                (err) => {
                    errorCallback(err)
                }
            );
    }

    getExistingPatientFunc = (
        patId,
        callback: (res: any) => void,
    ) => {
            this.enrollService
            .getExistingPatient(patId)
            .subscribe((res) => {
                this.setPatientProfileVals(res);
                callback(res);
            })
    }

    getEnrollPatientsFunc = (
        id,
        callback: (res: any) => void,
        errorCallback?: (err: any) => void
    ) => {
        this.requestService.enrollPatients(id).subscribe(
            (res) => {
                this.setPatientProfileVals(res);
                this.patRes = res;
                callback(res)
            },
            (err) => {
                errorCallback(err);
            }
        );
    }


    getEnrollPatientByInsFunc = (
        insNum,
        callback: (res: any) => void,
        errorCallback?: (err: any) => void
    ) => {
        this.patientFinderService
            .enrollPatientByIns(insNum)
            .subscribe(
                (patientDeviceData: PatientDeviceDataModel) => {
                    callback(patientDeviceData)
                },
                (err) => {
                    errorCallback(err);
                }
            );
    }

    getUpdateDeviceDataFunc = (
        payload,
        funcMode,
        patId,
        switchMapFn: (input: any) => Observable<any>,
        callback: (res: any) => void,
        errorCallback?: (err: any) => void
    ) => {
        this.enrollService
            .updateDeviceData(payload, funcMode, patId).pipe(
                switchMap(switchMapFn)
            )
            .subscribe(
                (res) => {
                    callback(res);
                },
                (err) => {
                    errorCallback(err);
                }
            );
    }

    setParentPatientid = (valToSet) => {
        this.patientid = valToSet;
    }

    setPatientProfileVals = (profile) => {
        this.patientInfo = profile;
        this.patientDeviceInfo = profile;
        this.dropDownInfo = profile.dropdowns;

        this.isPatientRelease = this.patientInfo?.patient?.patientStatusCd === 48 && this.patientInfo?.actionMsg !== null;
        this.setReleasePatientMessage(profile);

        if (
            this.patientInfo.showDeviceAtEos != null &&
            this.patientInfo.showDeviceAtEos != false
        ) {
            this.msg1 = this.translate('msg.pa900.text', null, ReturnType.Text);
        } else {
            this.msg1 = "";
        }
        if (
            this.patientInfo.correctAbbrDevModelDesc != null &&
            this.patientInfo.correctAbbrDevModelDesc != ''
        ) {
            this.msg2 = this.translate(
                'msg.pa899.text',
                { '0': this.patientInfo.correctAbbrDevModelDesc },
                ReturnType.Text
            );
        } else {
            this.msg2 = "";
        }

        if (
            this.patientInfo.showYellowBannerForApp != null &&
            this.patientInfo.showYellowBannerForApp != false
        ) {
            this.msg3 = this.translate('msg.pa890.text', null, ReturnType.Text);
        } else {
            this.msg3 = "";
        }

        const patientDevice = this.enrollService.getPrimaryPatientDevice(profile);
        this.rpCapableFlag = patientDevice?.patientRpCapableFlg ?? false;
    }

    setReleasePatientMessage = (profile) => {
        this.releasePatientMsg = this.localizationService.generateLocalizedStr(
            'msg.pa834a.text',
            null,
            'html'
        );
        if (
            profile.actionMsg?.msg &&
            (profile.actionMsg?.msg === 'msg.pa892.text' ||
                profile.actionMsg?.msg === 'msg.patrel_regclinic.text' ||
                profile.actionMsg?.msg === 'msg.patrel_actclinic.text')
        ) {
            let message = this.translate(
                profile.actionMsg?.msg,
                { 0: profile.actionMsg.data[0], 1: profile.actionMsg.data[1] },
                ReturnType.HTML
            );
            this.isPatientRelease = true;
            this.releasePatientMsg = message;
        }
    }

    translateTitle(key: string, params = null) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            'html'
        );
    }

    cancelButtonClick() {
        this.router.navigate(['/patient-list']);
    }
}
